export default "__VITE_ASSET__Pr9wNfwA__"